export enum DirectoryScreenNames {
  MAIN = 'directory',
  DIRECTORY = 'directory_list',
  CONTACT = 'contact',
}
